<template>
	<div id="cooperate">
		<div class="box">
			<h4 class="server"></h4>
			<div style="margin-bottom:93px;">
				<div class="title">
					本地镜像副本模式
				</div>
				<ul>
					<li><span></span>适用于大中型机构;</li>
					<li><span></span>“千年医典数据库”副本的本地镜像，一次采购永久使用，提供1-3年免费升级服务；</li>
					<li><span></span>服务期内副本免费内容升级与技术支持；</li>
					<li><span></span>提供机构管理员的专用管理模块</li>
					<li><span></span>平台所有功能和内容。</li>
				</ul>
			</div>
			<div style="margin-bottom:93px;">
				<div class="title">远程主站访问模式</div>
				<ul>
					<li><span></span>适用于微小型机构;</li>
					<li><span></span>“千年医典数据库”主站的远程访问服务，提供1-3年免费技术支持；</li>
					<li><span></span>服务期内副本免费内容升级与技术支持；</li>
					<li><span></span>平台部分功能和内容。</li>
				</ul>
			</div>
			<div>
				<div class="title">数据库定制模式</div>
				<ul>
					<li><span></span>适用于有特殊定制需求的机构客户;</li>
					<li><span></span>用户可选择“千年医典数据库”图书库中的部分分类或特定内容，定制个性化数据库；</li>
					<li><span></span>提供资源重整、程序重调、界面重设服务；</li>
					<li><span></span>定制数据库可以永久使用，提供2年免费升级与技术支持。</li>
				</ul>
			</div>
			<h4 class="contact"></h4>
			<div class="contact_box">
				<div class="contact_detail linkman">
					<div class="icon">
						联系人
					</div>
					<div class="text">
						<span class="name">宋女士</span> <br>(产品代理与直销联系)
					</div>
				</div>
				<div class="contact_detail qq">
					<div class="icon">
						邮箱
					</div>
					<div class="text">
						<span class="qq_number"></span>service@haiweikexin.com
					</div>
				</div>

				<div class="contact_detail phone">
					<div class="icon">
						电话
					</div>
					<div class="text">
						<span class="phone_number"></span>025-83420461
					</div>
				</div>
				<div class="clear"></div>
			</div>

		</div>
	</div>
</template>
<script>
export default{
	metaInfo: {
		title: '千年医典数据库-科学支撑中医临床、教学科研、健康养生',
		meta: [
			{ name: 'keywords', content: '购买中医古籍,在线智能阅读' },
			{ name: 'description', content: '需要购买中医海内外古籍或者在线智能阅读系统的请联系我们' }
		]
	},
	created(){
		const hashLocation = this.$route.path
		//   const newLocation = hashLocation.split("#/")[1];
		const url = "https://www.kanguji.com"+hashLocation
		this.$matomo.setCustomUrl(url);//覆盖页面报告的url，可以自定义页面url，加上本页面路由
		//   this.$matomo.trackEvent(shopCode,hashLocation);//事件
		// this.$matomo.trackPageView(hashLocation);//页面名称,可以自定义页面名称
	}
}
</script>

<style scoped lang="scss" type="text/css">
	#cooperate {
		border: 1px solid transparent;
		background: url(../../assets/public/bg1.png);
		.box {
			width: 1000px;
			height: 1150px;
			margin: 0 auto;
		}
		h4 {
			height: 28px;
			width: 1000px;
			margin-top: 60px;
		}
		.server {
			background: url(../../assets/cooperate/cooperate_service.png) no-repeat center center;
		}
		.contact {
			background: url(../../assets/cooperate/cooperate_contact.png) no-repeat center center;
		}
		.title {
			font-size: 20px;
			font-family: PingFangSC-Regular, sans-serif;
			font-weight: 400;
			height: 36px;
			color: #b17526;
			padding-left: 49px;
			padding-top: 4px;
			background: url(../../assets/cooperate/cooperate_subheading.png) no-repeat left center;
		}
		ul {
			margin-top: 13px;
			li {
				list-style: none;
				line-height: 30px;
				font-size: 16px;
				color: #333;
				font-family: PingFangSC-Light;
				font-weight: 300;
				span {
					width: 11px;
					height: 3px;
					display: inline-block;
					background-color: #b28850;
					vertical-align: middle;
					margin: 0 10px 0 27px;
					// font-family: PingFangSC-Light;
					// font-weight: 300;
				}
			}
		}
		.contact_box {
			margin-top: 38px;
			.contact_detail {
				width: 333px;
				/*//margin:0 134px 0 0;*/
				float: left;
				text-align: center;
				
				.icon {
					// height: 74px;
					padding-top: 58px;
					font-family: PingFangSC-Regular, sans-serif;
					font-weight: 400;
				}
				.text {
					background: url(../../assets/cooperate/cooperate_line_icon.png) no-repeat center top;
					padding-top: 40px;
					margin-top: 10px;
					font-size: 14px;
					font-family: PingFangSC-Regular, sans-serif;
					font-weight: 400;
					.name {
						font-size: 24px;
						font-family: PingFangSC-Regular, sans-serif;
						font-weight: 400;
					}
				}
			}
			.linkman .icon {
				background: url(../../assets/cooperate/cooperate_contact_icon.png) no-repeat top center;
			}
			.qq .icon {
				background: url(../../assets/cooperate/cooperate_qq_icon.png) no-repeat top center;
			}
			.phone .icon {
				background: url(../../assets/cooperate/cooperate_phone_icon.png) no-repeat top center;
			}
			.qq .text,
			.phone .text {
				font-size: 20px;
				padding-top: 54px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/page/cooperate.vue